import React from 'react';
import './Switch.css';

type SwitchProps = {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
};

const Switch: React.FC<SwitchProps> = ({ checked, onChange, label, disabled }) => (
  <button
    type="button"
    className={`mends-switch${checked ? ' is-on' : ''}`}
    role="switch"
    aria-checked={checked}
    disabled={disabled}
    onClick={() => onChange(!checked)}
  >
    <span className="mends-switch-track" aria-hidden="true">
      <span className="mends-switch-thumb" />
    </span>
    <span className="mends-switch-label">{label}</span>
  </button>
);

export default Switch;
